export const Footer = () => {
	return (
		<div style={{ position: "sticky", bottom: "16px", left: "16px" }}>
			<a href="https://www.linkedin.com/in/florian-bogner-84a907142/" target="_blank" rel="noreferrer">
				© Florian Bogner 2021
			</a>
		</div>
	)
}
